import { loadPolyfills as loadPolyfillsForInputs } from '@dhl/barcode-scanner-input'

export const loadPolyfills = (): Promise<unknown> => {
  if (window.location.href.includes('otc')) {
    return Promise.all([loadPolyfillsForInputs()])
  }

  return Promise.resolve()
}
